import React, { useEffect, useState } from "react";

export const uiContext = React.createContext();

export default function UiContextProvider({ children }) {
  const [descuentos, setDescuentos] = useState([]);

  useEffect(() => {
    var url = "https://store.lenken.com.ar/lenkenapi/autos/descuentos";

    fetch(url)
      .then((data) => {
        return data.json();
      })
      .then((data) => {
        setDescuentos(data);
      });

    /*     if (!localStorage.getItem("yavistioelsitio")) {
          localStorage.setItem("yavistioelsitio", "true");
        } */
  }, []);

  return (
    <uiContext.Provider value={{ descuentos: descuentos }}>
      {children}
    </uiContext.Provider>
  );
}
